<template>
    <footer>
        <section class="inline bg-default large" v-if="!glb.rentals && glb.pageType !== 'vhome'">
            <div class="flex center text-center wrap">
                <b>{{ molang('footer.meetAgentToday')}}</b>
                <a :href="'tel:' + getPhoneNumber" class="link">
                    <i class="icon-phone"></i>
                    <span>{{ $filters.formatPhoneNumber(getPhoneNumber) }}</span>
                </a>
            </div>
        </section>
        <section class="inline large">
            <div class="fixed fixed-max-sm">
                <div class="footer-links grid xs-grid-cols-1 sm-grid-cols-2 lg-grid-cols-4 gap-4" v-if="menu && menu.length">
                    <ul v-for="item in menu">
                        <li v-for="link in item" :key="link.text">
                            <div v-if="link.title" class="f4 text-bold">{{ link.title }}</div>
                            <a v-else-if="link.href" :href="link.href">
                                {{ link.text }}
                            </a>
                            <button v-else type="button" @click="link.click(link)">
                                {{ link.text }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="bg-white">
            <div class="fixed fixed-max-sm">
                <ul class="footer-logos">
                    <li>
                        <a :href="glb.appUrl"><img :src="glb.cdnUrl + 'vimages/movoto-lower-logo.svg'" alt="Movoto Logo"
                                loading="lazy"></a>
                    </li>
                    <li>
                        <a class="circle brand small" href="https://www.facebook.com/MovotoRealEstate"
                            aria-label="facebook" title="facebook">
                           <i class="icon-logo-facebook"></i>
                        </a>
                        <a class="circle brand small" href="https://x.com/movoto?lang=en" aria-label="X" title="X">
                            <i class="icon-logo-x"></i>
                        </a>
                        <a class="circle brand small" href="https://www.instagram.com/movotorealestate/"
                            aria-label="instagram" title="instagram">
                            <i class="icon-instagram"></i>
                        </a>
                        <a class="circle brand small" href="https://www.pinterest.com/movoto/" aria-label="pinterest"
                            title="pinterest">
                            <i class="icon-logo-pinterest"></i>
                        </a>
                        <a class="circle brand small" href="https://www.linkedin.com/company/movoto/"
                            aria-label="linkedin" title="linkedin">
                           <i class="icon-logo-linkin"></i>
                        </a>
                    </li>
                    <li>
                        <a href="https://apps.apple.com/app/apple-store/id537795977?pt=469170&ct=movoto.com%20footer&mt=8"
                            target="_blank" title="Movoto Real Estate iOS App">
                            <img class="applestore" style="width:103px; height:35px; font-size: 0;" loading="lazy"
                                alt="Download IOS APP"
                                :src="glb.cdnUrl + 'images/desktop/appdownload/applestore.svg'" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.movoto.movoto&utm_campaign=movotofooter"
                            target="_blank" title="Movoto Real Estate Android App">
                            <img class="googleplay" style="width:104px; height:35px; font-size: 0;" loading="lazy"
                                alt="Download Android APP"
                                :src="glb.cdnUrl + 'images/desktop/appdownload/googlestore.svg'" />
                        </a>
                    </li>
                </ul>
            </div>
        </section>
        <mvtCompliance />
    </footer>
</template>

<script src="./mvt-footer.js"></script>

<style lang="scss">
@use "./mvt-footer.scss" as *;
</style>
